import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';

import { ViewUpdateTprApiService } from '../../../../../../modules/api/view-update-tpr-api.service';

@Component({
    selector: 'tpr-add-modal',
    templateUrl: './tpr-add-modal.component.html',
    styleUrls: ['../../../tprecm.style.scss']
})
export class TprAddModalComponent {

    constructor(
        public readonly dialog: MatDialogRef<TprAddModalComponent>,
        private readonly viewUpdateTprApiService: ViewUpdateTprApiService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    form = new UntypedFormGroup({
        programId: new UntypedFormControl(null, Validators.required),
        toolNo: new UntypedFormControl(null, [(control: UntypedFormControl) => control.value && control.value.trim() ? null : { required: true }, Validators.maxLength(20), Validators.pattern('^[a-zA-Z0-9_-]*$')]),
        toolName: new UntypedFormControl(null, [(control: UntypedFormControl) => control.value && control.value.trim() ? null : { required: true }, Validators.maxLength(50)]),
        typeId: new UntypedFormControl(null, Validators.required),
        spanId: new UntypedFormControl(null, Validators.required),
        engineerId: new UntypedFormControl(null, Validators.required),
        stablePartCode1: new UntypedFormControl(null, [(control: UntypedFormControl) => control.value && control.value.trim() ? null : { required: true }, Validators.maxLength(50)]),
        stablePartCode2: new UntypedFormControl(null, [(control: UntypedFormControl) => control.value && control.value.trim() ? null : { required: true }, Validators.maxLength(50)]),
        partNumber: new UntypedFormControl(null, [(control: UntypedFormControl) => control.value && control.value.trim() ? null : { required: true }, Validators.maxLength(8)]),
        partNumber2: new UntypedFormControl(null, [(control: UntypedFormControl) => control.value && control.value.trim() ? null : { required: true }, Validators.maxLength(8)]),
        designSourceId: new UntypedFormControl(null, Validators.required),
        fixtureRequired: new UntypedFormControl(null, Validators.required)
    });

    addTpr() {
        const body = this.form.value;
        body.toolNo = body.toolNo.toUpperCase();
        body.toolName = body.toolName.toUpperCase();
        body.stablePartCode1 = body.stablePartCode1.toUpperCase();
        body.stablePartCode2 = body.stablePartCode2.toUpperCase();
        body.partNumber = body.partNumber.toUpperCase();
        body.partNumber2 = body.partNumber2.toUpperCase();
        this.viewUpdateTprApiService.addTpr(body)
            .subscribe(() => this.dialog.close(true));
    }
}
